"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

require("regenerator-runtime/runtime.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(loadPluginDescriptor),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(loadPresetDescriptor);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _gensync() {
  var data = _interopRequireDefault(require("gensync"));

  _gensync = function _gensync() {
    return data;
  };

  return data;
}

var _async = require("../gensync-utils/async");

var _util = require("./util");

var context = _interopRequireWildcard(require("../index"));

var _plugin = _interopRequireDefault(require("./plugin"));

var _item = require("./item");

var _configChain = require("./config-chain");

function _traverse() {
  var data = _interopRequireDefault(require("@babel/traverse"));

  _traverse = function _traverse() {
    return data;
  };

  return data;
}

var _caching = require("./caching");

var _options = require("./validation/options");

var _plugins = require("./validation/plugins");

var _configApi = _interopRequireDefault(require("./helpers/config-api"));

var _partial = _interopRequireDefault(require("./partial"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _gensync().default)( /*#__PURE__*/_regeneratorRuntime.mark(function loadFullConfig(inputOpts) {
  var result, options, context, optionDefaults, passes, plugins, presets, ignored, opts;
  return _regeneratorRuntime.wrap(function loadFullConfig$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _partial.default)(inputOpts), "t0", 1);

        case 1:
          result = _context2.t0;

          if (result) {
            _context2.next = 4;
            break;
          }

          return _context2.abrupt("return", null);

        case 4:
          options = result.options, context = result.context;
          optionDefaults = {};
          passes = [[]];
          _context2.prev = 7;
          plugins = options.plugins, presets = options.presets;

          if (!(!plugins || !presets)) {
            _context2.next = 11;
            break;
          }

          throw new Error("Assertion failure - plugins and presets exist");

        case 11:
          return _context2.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function recurseDescriptors(config, pass) {
            var plugins, i, descriptor, presets, _i, _descriptor, _iterator, _step, _step$value, preset, _pass, _ignored;

            return _regeneratorRuntime.wrap(function recurseDescriptors$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    plugins = [];
                    i = 0;

                  case 2:
                    if (!(i < config.plugins.length)) {
                      _context.next = 19;
                      break;
                    }

                    descriptor = config.plugins[i];

                    if (!(descriptor.options !== false)) {
                      _context.next = 16;
                      break;
                    }

                    _context.prev = 5;
                    _context.t0 = plugins;
                    return _context.delegateYield(loadPluginDescriptor(descriptor, context), "t1", 8);

                  case 8:
                    _context.t2 = _context.t1;

                    _context.t0.push.call(_context.t0, _context.t2);

                    _context.next = 16;
                    break;

                  case 12:
                    _context.prev = 12;
                    _context.t3 = _context["catch"](5);

                    if (i > 0 && _context.t3.code === "BABEL_UNKNOWN_PLUGIN_PROPERTY") {
                      (0, _options.checkNoUnwrappedItemOptionPairs)(config.plugins[i - 1], descriptor, "plugin", i, _context.t3);
                    }

                    throw _context.t3;

                  case 16:
                    i++;
                    _context.next = 2;
                    break;

                  case 19:
                    presets = [];
                    _i = 0;

                  case 21:
                    if (!(_i < config.presets.length)) {
                      _context.next = 40;
                      break;
                    }

                    _descriptor = config.presets[_i];

                    if (!(_descriptor.options !== false)) {
                      _context.next = 37;
                      break;
                    }

                    _context.prev = 24;
                    _context.t4 = presets;
                    return _context.delegateYield(loadPresetDescriptor(_descriptor, context), "t5", 27);

                  case 27:
                    _context.t6 = _context.t5;
                    _context.t7 = _descriptor.ownPass ? [] : pass;
                    _context.t8 = {
                      preset: _context.t6,
                      pass: _context.t7
                    };

                    _context.t4.push.call(_context.t4, _context.t8);

                    _context.next = 37;
                    break;

                  case 33:
                    _context.prev = 33;
                    _context.t9 = _context["catch"](24);

                    if (_i > 0 && _context.t9.code === "BABEL_UNKNOWN_OPTION") {
                      (0, _options.checkNoUnwrappedItemOptionPairs)(config.presets[_i - 1], _descriptor, "preset", _i, _context.t9);
                    }

                    throw _context.t9;

                  case 37:
                    _i++;
                    _context.next = 21;
                    break;

                  case 40:
                    if (!(presets.length > 0)) {
                      _context.next = 64;
                      break;
                    }

                    passes.splice.apply(passes, [1, 0].concat(_toConsumableArray(presets.map(function (o) {
                      return o.pass;
                    }).filter(function (p) {
                      return p !== pass;
                    }))));
                    _iterator = _createForOfIteratorHelper(presets);
                    _context.prev = 43;

                    _iterator.s();

                  case 45:
                    if ((_step = _iterator.n()).done) {
                      _context.next = 56;
                      break;
                    }

                    _step$value = _step.value, preset = _step$value.preset, _pass = _step$value.pass;

                    if (preset) {
                      _context.next = 49;
                      break;
                    }

                    return _context.abrupt("return", true);

                  case 49:
                    return _context.delegateYield(recurseDescriptors({
                      plugins: preset.plugins,
                      presets: preset.presets
                    }, _pass), "t10", 50);

                  case 50:
                    _ignored = _context.t10;

                    if (!_ignored) {
                      _context.next = 53;
                      break;
                    }

                    return _context.abrupt("return", true);

                  case 53:
                    preset.options.forEach(function (opts) {
                      (0, _util.mergeOptions)(optionDefaults, opts);
                    });

                  case 54:
                    _context.next = 45;
                    break;

                  case 56:
                    _context.next = 61;
                    break;

                  case 58:
                    _context.prev = 58;
                    _context.t11 = _context["catch"](43);

                    _iterator.e(_context.t11);

                  case 61:
                    _context.prev = 61;

                    _iterator.f();

                    return _context.finish(61);

                  case 64:
                    if (plugins.length > 0) {
                      pass.unshift.apply(pass, plugins);
                    }

                  case 65:
                  case "end":
                    return _context.stop();
                }
              }
            }, recurseDescriptors, null, [[5, 12], [24, 33], [43, 58, 61, 64]]);
          })({
            plugins: plugins.map(function (item) {
              var desc = (0, _item.getItemDescriptor)(item);

              if (!desc) {
                throw new Error("Assertion failure - must be config item");
              }

              return desc;
            }),
            presets: presets.map(function (item) {
              var desc = (0, _item.getItemDescriptor)(item);

              if (!desc) {
                throw new Error("Assertion failure - must be config item");
              }

              return desc;
            })
          }, passes[0]), "t1", 12);

        case 12:
          ignored = _context2.t1;

          if (!ignored) {
            _context2.next = 15;
            break;
          }

          return _context2.abrupt("return", null);

        case 15:
          _context2.next = 21;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t2 = _context2["catch"](7);

          if (!/^\[BABEL\]/.test(_context2.t2.message)) {
            _context2.t2.message = "[BABEL] ".concat(context.filename || "unknown", ": ").concat(_context2.t2.message);
          }

          throw _context2.t2;

        case 21:
          opts = optionDefaults;
          (0, _util.mergeOptions)(opts, options);
          opts.plugins = passes[0];
          opts.presets = passes.slice(1).filter(function (plugins) {
            return plugins.length > 0;
          }).map(function (plugins) {
            return {
              plugins: plugins
            };
          });
          opts.passPerPreset = opts.presets.length > 0;
          return _context2.abrupt("return", {
            options: opts,
            passes: passes
          });

        case 27:
        case "end":
          return _context2.stop();
      }
    }
  }, loadFullConfig, null, [[7, 17]]);
}));

exports.default = _default;
var loadDescriptor = (0, _caching.makeWeakCache)( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, cache) {
  var value, options, dirname, alias, item, api;
  return _regeneratorRuntime.wrap(function _callee$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          value = _ref.value, options = _ref.options, dirname = _ref.dirname, alias = _ref.alias;

          if (!(options === false)) {
            _context3.next = 3;
            break;
          }

          throw new Error("Assertion failure");

        case 3:
          options = options || {};
          item = value;

          if (!(typeof value === "function")) {
            _context3.next = 15;
            break;
          }

          api = Object.assign({}, context, (0, _configApi.default)(cache));
          _context3.prev = 7;
          item = value(api, options, dirname);
          _context3.next = 15;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](7);

          if (alias) {
            _context3.t0.message += " (While processing: ".concat(JSON.stringify(alias), ")");
          }

          throw _context3.t0;

        case 15:
          if (!(!item || typeof item !== "object")) {
            _context3.next = 17;
            break;
          }

          throw new Error("Plugin/Preset did not return an object.");

        case 17:
          if (!(typeof item.then === "function")) {
            _context3.next = 20;
            break;
          }

          return _context3.delegateYield([], "t1", 19);

        case 19:
          throw new Error("You appear to be using an async plugin, " + "which your current version of Babel does not support. " + "If you're using a published plugin, " + "you may need to upgrade your @babel/core version.");

        case 20:
          return _context3.abrupt("return", {
            value: item,
            options: options,
            dirname: dirname,
            alias: alias
          });

        case 21:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee, null, [[7, 11]]);
}));

function loadPluginDescriptor(descriptor, context) {
  return _regeneratorRuntime.wrap(function loadPluginDescriptor$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!(descriptor.value instanceof _plugin.default)) {
            _context4.next = 4;
            break;
          }

          if (!descriptor.options) {
            _context4.next = 3;
            break;
          }

          throw new Error("Passed options to an existing Plugin instance will not work.");

        case 3:
          return _context4.abrupt("return", descriptor.value);

        case 4:
          _context4.t0 = instantiatePlugin;
          return _context4.delegateYield(loadDescriptor(descriptor, context), "t1", 6);

        case 6:
          _context4.t2 = _context4.t1;
          _context4.t3 = context;
          return _context4.delegateYield((0, _context4.t0)(_context4.t2, _context4.t3), "t4", 9);

        case 9:
          return _context4.abrupt("return", _context4.t4);

        case 10:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked);
}

var instantiatePlugin = (0, _caching.makeWeakCache)( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, cache) {
  var value, options, dirname, alias, pluginObj, plugin, inheritsDescriptor, inherits;
  return _regeneratorRuntime.wrap(function _callee2$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          value = _ref2.value, options = _ref2.options, dirname = _ref2.dirname, alias = _ref2.alias;
          pluginObj = (0, _plugins.validatePluginObject)(value);
          plugin = Object.assign({}, pluginObj);

          if (plugin.visitor) {
            plugin.visitor = _traverse().default.explode(Object.assign({}, plugin.visitor));
          }

          if (!plugin.inherits) {
            _context5.next = 12;
            break;
          }

          inheritsDescriptor = {
            name: undefined,
            alias: "".concat(alias, "$inherits"),
            value: plugin.inherits,
            options: options,
            dirname: dirname
          };
          return _context5.delegateYield((0, _async.forwardAsync)(loadPluginDescriptor, function (run) {
            return cache.invalidate(function (data) {
              return run(inheritsDescriptor, data);
            });
          }), "t0", 7);

        case 7:
          inherits = _context5.t0;
          plugin.pre = chain(inherits.pre, plugin.pre);
          plugin.post = chain(inherits.post, plugin.post);
          plugin.manipulateOptions = chain(inherits.manipulateOptions, plugin.manipulateOptions);
          plugin.visitor = _traverse().default.visitors.merge([inherits.visitor || {}, plugin.visitor || {}]);

        case 12:
          return _context5.abrupt("return", new _plugin.default(plugin, options, alias));

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee2);
}));

var validateIfOptionNeedsFilename = function validateIfOptionNeedsFilename(options, descriptor) {
  if (options.test || options.include || options.exclude) {
    var formattedPresetName = descriptor.name ? "\"".concat(descriptor.name, "\"") : "/* your preset */";
    throw new Error(["Preset ".concat(formattedPresetName, " requires a filename to be set when babel is called directly,"), "```", "babel.transform(code, { filename: 'file.ts', presets: [".concat(formattedPresetName, "] });"), "```", "See https://babeljs.io/docs/en/options#filename for more information."].join("\n"));
  }
};

var validatePreset = function validatePreset(preset, context, descriptor) {
  if (!context.filename) {
    var options = preset.options;
    validateIfOptionNeedsFilename(options, descriptor);

    if (options.overrides) {
      options.overrides.forEach(function (overrideOptions) {
        return validateIfOptionNeedsFilename(overrideOptions, descriptor);
      });
    }
  }
};

function loadPresetDescriptor(descriptor, context) {
  var preset;
  return _regeneratorRuntime.wrap(function loadPresetDescriptor$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.t0 = instantiatePreset;
          return _context6.delegateYield(loadDescriptor(descriptor, context), "t1", 2);

        case 2:
          _context6.t2 = _context6.t1;
          preset = (0, _context6.t0)(_context6.t2);
          validatePreset(preset, context, descriptor);
          return _context6.delegateYield((0, _configChain.buildPresetChain)(preset, context), "t3", 6);

        case 6:
          return _context6.abrupt("return", _context6.t3);

        case 7:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked2);
}

var instantiatePreset = (0, _caching.makeWeakCacheSync)(function (_ref3) {
  var value = _ref3.value,
      dirname = _ref3.dirname,
      alias = _ref3.alias;
  return {
    options: (0, _options.validate)("preset", value),
    alias: alias,
    dirname: dirname
  };
});

function chain(a, b) {
  var fns = [a, b].filter(Boolean);
  if (fns.length <= 1) return fns[0];
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _iterator2 = _createForOfIteratorHelper(fns),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var fn = _step2.value;
        fn.apply(this, args);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
}